class FingerfoodService {
    fingerfood = [
        {
            category: "fingerfood",
            id: 1,
            title: "Chicken Nuggets",
            subscription: "9 Stück Mit Brötchen und Sauce",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 5.50
                } ,
            image: "nuggets.png",
        },
        {
            category: "fingerfood",
            id: 2,
            title: "Chicken Nuggets",
            subscription: "15 Stück Mit Brötchen und Sauce",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 6.90
                } ,
            image: "nuggets.png",
        },
        {
            category: "fingerfood",
            id: 3,
            title: "Pommes frites",
            subscription: "Mit Brötchen und Sauce",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 2.00
                } ,
            image: "potato.png",
        },
        {
            category: "fingerfood",
            id: 4,
            title: "Currywurst",
            subscription: "Mit Brötchen und Currysauce",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 6.70
                } ,
            image: "currywurst.png",
        },
        {
            category: "fingerfood",
            id: 5,
            title: "Currywurst",
            subscription: "Mit Pommes",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 7.50
                } ,
            image: "currywurst-pommes.png",
        },
        {
            category: "fingerfood",
            id: 6,
            title: "Grill-Bratwurst",
            subscription: "Mit Brötchen und 1 Sauce nach Wah",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 4.90
                } ,
            image: "grill-bratwurst.png",
        },
        {
            category: "fingerfood",
            id: 7,
            title: "Grill-Bratwurst",
            subscription: "Mit Pommes",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 6.40
                } ,
            image: "grill-bratwurst-pommes.png",
        },
        {
            category: "fingerfood",
            id: 8,
            title: "Französischer Hot Dog",
            subscription: "Mit Geflügel-Wüstchen 2 Sauce nach Wah",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 2.60
                } ,
            image: "frenchdog.png",
        },
        {
            category: "fingerfood",
            id: 9,
            title: "Französischer Hot Dog",
            subscription: "Mit Bratwüstchen 2 Sauce nach Wahl",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 2.60
                } ,
            image: "frenchdog.png",
        },
        {
            category: "fingerfood",
            id: 10,
            title: "Hot Dog",
            subscription: "Mit Geflügel-Wüstchen 2 Sauce nach Wahl",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 3.50
                } ,
            image: "hotdog.png",
        },
        {
            category: "fingerfood",
            id: 11,
            title: "Hot Dog",
            subscription: "Mit Bratwüstchen 2 Sauce nach Wahl",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 3.50
                } ,
            image: "hotdog.png",
        },
        {
            category: "fingerfood",
            id: 12,
            title: "Chicken wings",
            subscription: "12 Stück mit Brötchen und Sauce",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 7.00
                } ,
            image: "wings.png",
        },
        {
            category: "fingerfood",
            id: 13,
            title: "Chicken wings",
            subscription: "15 Stück mit Brötchen und Sauce",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 8.50
                } ,
            image: "wings.png",
        },
        {
            category: "fingerfood",
            id: 14,
            title: "Kroketten",
            subscription: "10 Stück",
            volume: {
                small: "",
                large: ""
            },
            prices:
                {
                    small: 2.50
                } ,
            image: "krokets.png",
        },
    ];

    getFingerfood() {
        //Cимуляция работы с сервером
        return new  Promise((resolve, reject) => {
            setTimeout(() => {
                if (Math.random() > 1) {
                    reject(new Error())
                } else {
                    resolve(this.fingerfood);
                }
            }, 10);
        });
    }
}

export default new FingerfoodService();